import React from "react";
//import "../../WordDetective.css"; // keep the styles for skeleton

/**
 * SkeletonLoader Component
 * Shows animated loading placeholder while HexiLexi is thinking.
 * Styled to look like an incoming chat bubble.
 */

const SkeletonLoader = () => (
  <div className="skeleton-container">
    <div className="skeleton-avatar">
      <span role="img" aria-label="thinking">🔮</span>
    </div>
    <div className="skeleton-bubble">
      <div className="skeleton-typing-dots">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
      <div className="skeleton-line" style={{ width: '85%', animationDelay: '0s' }}></div>
      <div className="skeleton-line" style={{ width: '65%', animationDelay: '0.1s' }}></div>
      <div className="skeleton-line" style={{ width: '45%', animationDelay: '0.2s' }}></div>
      
    </div>
  </div>
);

export default SkeletonLoader;